import gql from 'graphql-tag'

export const ADMIN_SUBSCRIPTION_NOTIFICATION_LOGS_QUERY = gql`
  query AdminSubscriptionNotificationLogs($deviceId: Int, $limit: Int) {
    adminSubscriptionNotificationLogs(deviceId: $deviceId, limit: $limit) {
      id
      userId
      deviceId
      daysBeforeExpiry
      subscriptionExpiryDate
      sentAt
      notificationType
      userEmail
      userFirstName
      userLastName
      deviceName
      deviceController
      companyName
    }
  }
`
